import apiClient from "../config/apiClient";


export const bookAppointment = async (data) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.post(`/public/portal?url=front-desk/appointments/new`, {
      booking_source: "portal",
      ...data,
    }, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
  // front-desk/appointments/new